
export const DBConfig = {
    name: "InUAV1",
    version: 1,
    objectStoresMeta: [
        {
            store: "votes",
            storeConfig: { keyPath: "key", autoIncrement: false },
            storeSchema: [
                { name: "status", keypath: "status", options: { unique: false } },
                { name: "key", keypath: "key", options: { unique: true } },
                { name: "timestamp", keypath: "timestamp", options: { unique: false } },
                { name: "tournament", keypath: "id_tournament", options: { unique: false } },
                { name: "participant", keypath: "id_tournament_participant", options: { unique: false } },
                { name: "judge", keypath: "id_tournament_judge", options: { unique: false } },
                { name: "vote", keypath: "vote", options: { unique: false } },
                { name: "synchronized", keypath: "synchronized", options: { unique: false } },
                { name: "comments", keypath: "comments", options: { unique: false } },
            ],
        }
    ],
};
